import { LeaderboardResponse } from '../types';
import axiosInstance from './axiosInstance';

export async function getLeaderboard() {
  const response = await axiosInstance.get('/leaderboard');

  return response.data as LeaderboardResponse[];
}
